<app-page-heading [title]="formTitle" [subheadingIcon]="'fa fa-user-plus'"></app-page-heading>

<app-user-form #userForm
               [user]="user"
               [mode]="mode"
               [userTypeLabelKey]="'user-dashboard.groups.carrier-manager'"
               [create]="onCreate"
               [update]="onUpdate"
               [remove]="currentUserIsCarrierManager ? null : onDelete"
               [block]="onToggleBlocking"
               [unblockIp]="onUnblockIp"
               [canActivateBluechat]="isBluechatActivatedOnCarrier"
               (enableBluechat)="enableBluechat($event)"
               (changePassword)="changePassword($event)"
               (afterCreate)="goToManagerList()"
               (afterDelete)="goToManagerList()"
>
</app-user-form>
